import { usePage } from "@/components/page/PageContext";
import { PlayListDisplay } from "@/components/playlist/PlayListDisplay";
import { useEffect } from "react";

export function PlaysPage() {
  const { setTitles } = usePage();
  useEffect(() => {
    setTitles(["All Pain Points"]);
  }, []);

  return <PlayListDisplay />;
}
